import axios from 'axios';
import router from '../../router/index';
import { Message } from 'element-ui';
import { showLoading, hideLoading } from '../loading';

// 设置请求头请求格式为form
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 设置cross跨域访问权限
axios.defaults.crossDomain = true;
// 允许跨域携带cookie信息
axios.defaults.withCredentials = true;

let baseURL = '';
if (process.env.NODE_ENV === 'development') {
    baseURL = '';
} else {
    baseURL = 'https://acquizi.com';
}

const Axios = axios.create({
    baseURL: baseURL,
    timeout: 30000 // 设置请求超时时间30秒
});

// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
    showLoading();
    if (window.localStorage.getItem('User-Token')) {
        config.headers['User-Token'] = window.localStorage.getItem('User-Token');
    }
    return config;
}, function (error) {
    // 请求错误 4XX
    hideLoading();
    Message.error('接口请求异常');
    return Promise.reject(error);
});
// Axios response 中间件，在接口请求后插入处理逻辑
Axios.interceptors.response.use(function (response) {
    return sendSuccess(response);
}, async function (error) {
    // 判断请求异常信息中是否含有超时timeout字符串
    if (error.message.includes('timeout')) {
        hideLoading();
        return Promise.resolve({ msg: '请求超时，请稍候再试' });
    } else {
        // 响应错误 5XX
        Message.error('接口响应异常');
        hideLoading();
        return Promise.reject(error);
    }
});

function sendSuccess (response) {
    hideLoading();
    let data = response.data;
    const status = response.status;
    if (status === 200 && data.code === 200) {
        // 接口响应正常
        return data;
    } else if (status === 200 && data.code === 500) {
        // 入参不对后台返回提示
        Message.error(data.msg);
        return Promise.reject(new Error('接口数据异常'));
    } else if (status === 200 && data.code === 900) {
        // 登录失效到登录界面重新登录
        Message.error({
            message: data.msg,
            duration: 1000,
            onClose: () => {
                router.replace({
                    path: '/'
                });
            }
        });
        return Promise.reject(new Error('接口数据异常'));
    } else {
        // 接口返回数据格式错误 例如没有code 返回的是html
        if (data.constructor !== Object) {
            data = {};
        }
        Message.error(data.msg || '接口数据异常');
        return Promise.reject(new Error('接口数据异常'));
    }
}

export default Axios;



// WEBPACK FOOTER //
// ./src/common/axios/index.js